import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Notifications } from "@mantine/notifications";
import AppRoutes from "./routes";
import { NOTIFICATION_AUTO_CLOSE_MS } from "@/shared/constants/notification.const";
import { NOTIFICATIONS_Z_INDEX } from "@/shared/constants/overlayZIndex.const";
import { UserProvider } from "@/context/UserContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { CollaborationHelpProvider } from "@/context/CollaborationHelpContext";
import GtsetuHelpFloatingBot from "@/components/help/GtsetuHelpFloatingBot";
import { ScrollToTop } from "./components/ScrollToTop";
import { useEffect, useState } from "react";
import OfflinePage from "./pages/offline/OfflinePage";
import { queryClient } from "@/state/queryClient";

// Mantine theme configuration
function App() {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <Notifications
        position="top-right"
        zIndex={NOTIFICATIONS_Z_INDEX}
        autoClose={NOTIFICATION_AUTO_CLOSE_MS}
        portalProps={{ reuseTargetNode: true }}
      />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <UserProvider>
            <NotificationProvider>
              <CollaborationHelpProvider>
                <ScrollToTop />
                <AppRoutes />
                <GtsetuHelpFloatingBot />
              </CollaborationHelpProvider>
            </NotificationProvider>
          </UserProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </>
  );
}

export default App;
